<template>
  <div class="venue-select">
    <h2>选择场地</h2>

    <van-radio-group v-model="selectedVenue">
      <van-cell-group>
        <van-cell
          v-for="(item,i) in venues"
          :key="item.id"
          :title="item.area_name"
          clickable
          @click="clickVenue(item)"
        >
          <template #right-icon>
            <van-radio :name="item.id" />
          </template>
        </van-cell>
      </van-cell-group>
    </van-radio-group>

    <!-- 下一步按钮：只有选中了场地才可点击 -->
    <van-button
      type="primary"
      block
      style="margin-top: 30px;"
      @click="goNext"
    >
      下一步
    </van-button>
  </div>
</template>

<script>
import req from '@/utils/request2.js';
export default {
  name: 'SelectVenue',
  data() {
    return {
      selectedVenue: '' || '', // 支持从 Vuex 恢复
      selectedData:{},
      venues: [
    
    ],
    serveIp:"",
    outdoorRunnControlData:{}
    }
  },
  watch: {
    // 一旦选中，立即提交到 Vuex（可选，也可在 goNext 时提交）
    selectedVenue(newVal) {
    //   if (newVal) {
    //     this.$store.commit('setVenue', newVal)
    //   }
    }
  },
  mounted () {
    this.serveIp = this.$route.query.serveIp||""
    this.outdoorRunnControlData = JSON.parse(localStorage.getItem("outdoorRunnControlData"))
    this.jiekou()
  },
  methods: {
    clickVenue(item){
        this.selectedData = item
        this.selectedVenue = item.id
        // this.selectedVenue = item.name
        console.log(item);
        
    },
    async jiekou(){
        // let data = {}
       await req.post({
          url:`${this.serveIp}/getAreaListInfo`,
          data:{},
        }).then(res=>{
          console.log("sss",res);
          
          this.venues = res.data||[]
          if (this.venues.length>0) {
            this.selectedVenue = this.venues[0].id
            this.selectedData = this.venues[0]
          }
        // this.$toast('操作成功');
        })
    },
    goNext() {
      if (!this.selectedVenue) {
        this.$toast('请选择一个场地')
        return
      }
      // outdoorRunnControlData outdoorRunnControlData

      this.$set(this.outdoorRunnControlData,"VenueId",this.selectedData.id)
      this.$set(this.outdoorRunnControlData,"VenueName",this.selectedData.area_name)
      localStorage.setItem('outdoorRunnControlData',JSON.stringify(this.outdoorRunnControlData))
      
      this.$router.push('/outdoorRunning/DeviceStatus')
    }
  }
}
</script>

<style scoped>
.venue-select {
  padding: 20px;
}
</style>